<template>
    <div>
        <v-layout row wrap justify-center align-end>
            <v-flex xs9 sm7 md4 class="contenedor-logo">
                <img class="img-logo" :src="require('@/assets/imagenes_compartidas/logo.png')" alt="">
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logos:[
                'logo-1',
            ]
        }
    },
}
</script>
<style lang="scss" scoped>
  .contenedor-logo{
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
  }
  img.img-logo{
      height: 50%;
  }
</style>